import React, { useEffect, createElement } from 'react';
import AdvertorialGlpPlateau2 from '../components/AdvertorialGlpPlateau2';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpPlateau2Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID matching /glp-adv-6
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'GLP-1 Plateau Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18641">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18642">
        <Helmet data-id="element-18643">
          <title data-id="element-18644">
            Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1
            Users... Maybe Even You
          </title>
          <meta property="og:title" content="Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1 Users... Maybe Even You" data-id="element-18645" />
          <meta property="og:description" content="The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And The Breakthrough Protocol That's Bringing Back Joy Without Stopping The Weight Loss" data-id="element-18646" />
          <meta property="og:type" content="article" data-id="element-18647" />
          <meta property="og:url" content={window.location.href} data-id="element-18648" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18649" />
          <meta property="og:image:width" content="1200" data-id="element-18650" />
          <meta property="og:image:height" content="630" data-id="element-18651" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18652" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18653" />
          <meta name="twitter:title" content="Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1 Users... Maybe Even You" data-id="element-18654" />
          <meta name="twitter:description" content="The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And The Breakthrough Protocol That's Bringing Back Joy Without Stopping The Weight Loss" data-id="element-18655" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18656" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18657" />
        </Helmet>
        <AdvertorialGlpPlateau2 data-id="element-18658" />
      </div>
    </HelmetProvider>;
}